(function($) {
$(document).ready(function() {

// Cache elements
$$.tiles = $('.tiles');
$$.rows = $('.row');
$$.allTiles = $('.tile');
$$.allInputs = $('input.letter');

// App preferences
app.id = 'unboggler';
app.workerPath = app.path.resources + '/scripts/workers/unboggler.worker.min.js';
// Get number of rows and columns
app.nrows = $$.rows.length;
app.ncols = $$.allTiles.length / app.nrows;

// Create map of letters
function getLetterMatrix() {
	var letterMatrix,
		$input,
		r, c, i;

	letterMatrix = [];
	i = 0;
	for (r = 0; r < app.nrows; r += 1) {
		letterMatrix[r] = [];
		for (c = 0; c < app.ncols; c += 1) {
			$input = $$.allInputs.eq(i);
			letter = $input.val();
			if (letter === '') {
				letter = 'a';
				$input.val(letter);
			}
			letter = letter.toLowerCase();
			letterMatrix[r].push(letter);
			i += 1;
		}
	}

	return letterMatrix;
}

// Create map of letters
function setLetterMatrix(letterMatrix) {
	var r, c, i;

	i = 0;
	for (r = 0; r < app.nrows; r += 1) {
		for (c = 0; c < app.ncols; c += 1) {
			$$.allInputs[i].value = letterMatrix[r][c];
			i += 1;
		}
	}
	return letterMatrix;
}

// Load word from local storage
function load() {
	var data;
	if (window.localStorage) {

		// Load app data from LS
		data = localStorage.getItem('unboggler');
		if (data !== null) {

			// Parse and set app data
			data = JSON.parse(data);
			setLetterMatrix(data.letterMatrix);

		}
	}

}

// Save word to local storage (LS)
function save() {
	var letterMatrix, data;
	if (window.localStorage) {

		letterMatrix = getLetterMatrix();

		// Create data object
		data = {
			letterMatrix: letterMatrix
		};
		// Save data object to LS
		localStorage.setItem('unboggler', JSON.stringify(data));

	}
}

// Run solver
function run() {
	var letterMatrix;

	if (app.ready === true && app.running === false) {

		letterMatrix = getLetterMatrix();

		app.start();

		app.data = {
			nrows: app.nrows,
			ncols: app.ncols,
			letterMatrix: letterMatrix,
			words: app.dictionary
		};

		// If browser supports web workers
		if (app.supports.workers) {

			// If worker does not exist
			if (app.worker === null) {
				// Create new worker
				app.worker = new Worker(app.workerPath);
				app.worker.onmessage = app.end;
			}

			// Delay worker execution to ease stress on main thread
			setTimeout(function() {
				// Start worker
				app.worker.postMessage(app.data);
			}, 10);

		} else {

			// Load Trie library via AJAX
			$.getScript(app.path.trie, function() {

				// Load Boggle solver engine via AJAX
				$.getScript(app.path.boggle, function() {
					// Fallback for web workers

					// Callback to display unscrambled words
					window.callback = app.end;

					// Import worker as synchronous script
					$.getScript(app.workerPath);

				});

			});

		}

		save();
	}
}
app.run = run;

// When a key is pressed in input
$$.tiles.on('keydown', 'input', function(event) {
	var $input, index,
		prevIndex, nextIndex;

	// Record the most recently focused input and its value
	$input = $(this);
	app.lastValue = $input.val();
	app.lastInput = $input[0];

	if (event.which === 9) {

		index = $input.index('input');

		if (event.shiftKey) {

			// Select previous input with SHIFT+TAB
			prevIndex = index - 1;
			if (prevIndex < 0) {
				// Wrap around if necessary
				prevIndex = (app.nrows * app.ncols) - 1;
			}
			index = prevIndex;

		} else {
			// Otherwise, select next input with TAB

			// Determine index of next input
			nextIndex = index + 1;
			if (nextIndex >= (app.nrows * app.ncols)) {
				// Wrap around if necessary
				nextIndex = 0;
			}
			index = nextIndex;

		}

		// Select neighboring input
		$$.allInputs
		.eq(index)
		.trigger('select');

		// Prevent default tabbing
		event.preventDefault();

	} else if (event.which === 13) {

		// Press ENTER to run unboggler
		run();

	}

});

// When a key is released in input
$$.tiles.on('keyup', 'input', function(event) {
	var $input, $tile,
		letter,
		index, nextIndex;

	// Retrieve input and its value
	$input = $(this);
	letter = $input.val();

	// If user changed or overwrote the input's value somehow
	if (app.lastInput === this && (app.lastValue !== letter || (event.which >= 65 && event.which <= 90)) && event.which !== 8 && event.which !== 46) {

		// Retrieve parent tile
		$tile = $input.parent('.tile');

		letter = letter.toLowerCase();
		letter = letter.replace(/([^a-z])/gi, '');

		if (letter === '') {
			// Entered letter cannot be empty
			letter = 'a';
		} else if (letter.length > 1) {
			// Entered letter cannot be more than one letter
			letter = letter[letter.length - 1];
		}

		if (letter === 'q') {
			// Q is always followed by U
			letter = 'qu';
		}

		// Update value of input with valid value
		$input.val(letter);

		save();

	}

});

// Click input to select it
$$.tiles.on('click', 'input', function() {
	var $input;
	$input = $(this);
	$input.trigger('select');
});

load();

$$.allInputs.eq(0).trigger('select');

});
}(jQuery));
